import React, {createRef, useEffect, useState} from 'react';
import {useQueryClient} from "react-query";
import moment from "moment";
import {Grid, InputLabel} from "@material-ui/core";

import {FormDialog, Text }from "../../../controls";
import Validator from "../validators/CateringOrderVersionsValidator";
import CateringOrdersList from "./CateringOrdersList";

const CateringOrderVersionsDialog = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const SystemData = props.systemData;
  const extraKeys = props.extraKeys;
  const classes = props.classes;
  const canEdit = props.canEdit;
  const eventBus = SystemData.eventBus;

  const dateFormat = "DD/MM/YYYY";
  const queryClient = useQueryClient();

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    record: {},
    title: 'Edit Crew',
    skeletonCrew: null,
    extraKeys: extraKeys
  });

  useEffect(()=> {
    const open = async (record, updateKeys) => {
      const title = `Previous Catering Order Versions ${record.airlineCode}${record.flightNo} on ${record.flightDate ? moment.utc(record.flightDate).format("DD MMM YYYY") : ""}`;

      setDialogStates(
        {
          ...dialogStates,
          showDialog:true,
          title,
          extraKeys: updateKeys||extraKeys,
          record,
        }
      );
    }
    eventBus.bind("CateringOrderVersionsDialog.open", open);

    return () => {
      eventBus.unbind("CateringOrderVersionsDialog.open", open);
    }
  }, [dialogStates, eventBus, extraKeys]);


  if (dialogStates.showDialog) {
    return (
      <FormDialog
        title={dialogStates.title}
        message=""
        open={dialogStates.showDialog}
        record={dialogStates.record}
        dialogOptions={{maxWidth: "xl", fullWidth: true}}
        classes={classes}
        validator={Validator}
        buttons = {{
          // save:{icon: "check_circle", key: "Save", label: "Save", color: "primary", disabled: (status)=>{return status.error}},
          cancel:{icon: "cancel", key: "Close", label: "Close", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            // const record = state.record;
            // handleUpdate.mutate({
            //   extraKeys: dialogStates.extraKeys,
            //   record,
            //   postSuccess: () => {
            //     setDialogStates({...dialogStates, showDialog: false, record: null});
            //     if (props.afterSave) {
            //       props.afterSave();
            //     }
            //     if (typeof props.onClose === 'function') {props.onClose()}
            //   },
            //   postError: (data) => {
            //     if (props.onError) {
            //       props.onError(data);
            //     } else if (data.errorMessage) {
            //       SystemData.alert("Error", `${data.errorMessage}`);
            //     } else {
            //       SystemData.alert("Error", `An Unexpected Error has occurred.`);
            //     }
            //   }
            // });
          } else {
            setDialogStates({...dialogStates, showDialog: false, record: null});
            if (typeof props.onClose === 'function') {props.onClose()}
          }
        }}

      >
        <Grid container checkChildren={true} spacing={3}>
          <Grid item xs={2} checkChildren={true}>
            {(record, changeRecord) => (
              <div>
                <InputLabel shrink>
                  Flight Number
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${record.airlineCode}-${record.flightNo}`}
                />
              </div>
            )}
          </Grid>

          <Grid item xs={2} checkChildren={true}>
            {(record, changeRecord) => (
              <div>
                <InputLabel shrink>
                  Flight Date
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${moment(record.flightDate, "YYYY-MM-DD HH:mm:ss").format(dateFormat)}`}
                />
              </div>
            )}
          </Grid>

          <Grid item xs={2} checkChildren={true}>
            {(record, changeRecord) => (
              <div>
                <InputLabel shrink>
                  Trip Number
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`MAG${record.tripNo}`}
                />
              </div>
            )}
          </Grid>

          <Grid item xs={6} checkChildren={true}>
            {(record, changeRecord) => (
              <div className="d-flex flex-row justify-content-between align-items-center">
                <InputLabel shrink>
                  Airport
                </InputLabel>

                <Text
                  style={{width: "100%", marginTop: 2, display: "inline-block"}}
                  defaultValue={`${record.airportCode}`}
                />
              </div>
            )}
          </Grid>
        </Grid>

        <Grid container checkChildren={true} spacing={3}>
          <Grid item xs={12} checkChildren={true}>
            {(record, changeRecord) => (
              <CateringOrdersList
                classes={classes}
                canEdit={canEdit}
                parentOrder={record.cateringOrderUuid}
                orderVersionsMode
              />
            )}
            </Grid>
        </Grid>
      </FormDialog>
    )
  }
  return (<></>);
}

export default CateringOrderVersionsDialog;
